function searchFunc(btn, form, closeBoi, field) {
  var searchBtn = document.querySelector(btn);
  var searchForm = document.querySelector(form);
  var closer = document.querySelector(closeBoi);
  var input = document.getElementById(field);
  var active = "search-is-active";
  searchBtn.addEventListener("click", function (e) {
    e.preventDefault();
    params = new URLSearchParams({
      s: input.value,
    });
    if (searchForm.classList.contains(active)) {
      searchForm.classList.remove(active);
      closer.classList.remove("search-closer__active");
      this.classList.remove("active-btn");
      if (input.value.length >= 3) {
        window.open("/?" + params.toString(), "_self");
      }
    } else {
      setTimeout(function () {
        input.focus();
      }, 200);
      searchForm.classList.add(active);
      this.classList.add("active-btn");
      closer.classList.add("search-closer__active");
    }

    if (
      this.classList.contains("active-btn") &&
      input.value != "" &&
      input.value.length >= 3
    ) {
      window.open("/?" + params.toString(), "_self");
    }
  });

  document.addEventListener("keyup", function (event) {
    if (event.code === "Escape") {
      if (searchBtn.classList.contains("active-btn")) {
        searchBtn.classList.remove("active-btn");
        closer.classList.remove("search-closer__active");
        searchForm.classList.remove(active);
        input.value = "";
      }
    }

    if (event.code === "Enter") {
      params = new URLSearchParams({
        s: input.value,
      });
      if (
        searchBtn.classList.contains("active-btn") &&
        input.value.length >= 3
      ) {
        window.open("/?" + params.toString(), "_self");
      }
    }
  });

  document.onkeydown = function (e) {
    e = e || window.event;
    var isEnter = false;
    if ("key" in e) {
      isEnter = e.key === "Enter";
    } else {
      isEnter = e.code === 13;
    }

    if (
      isEnter &&
      input.value != "" &&
      input.length >= 3 &&
      searchBtn.classList.contains("active-btn")
    ) {
      params = new URLSearchParams({
        s: input.value,
      });
      window.open("/?" + params.toString(), "_self");
    }
  };

  closer.addEventListener("click", function () {
    searchBtn.classList.remove("active-btn");
    this.classList.remove("search-closer__active");
    searchForm.classList.remove(active);
    input.value = "";
  });
}

document.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    $("#desktop_search").on("input", function (e) {
      e.preventDefault();
      if ($(this).val().length >= 3) {
        $(this).addClass("search-active");
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          dataType: "html",
          data: {
            action: "duikhuis_search",
            query: $(this).val(),
          },
          beforeSend: function () {
            $(".site-header__nav--desktop__search--results").addClass(
              "site-header__nav--desktop__search--results__loading"
            );
          },
          success: function (res) {
            $(".site-header__nav--desktop__search--results").html(res);
            $(".site-header__nav--desktop__search--results").removeClass(
              "site-header__nav--desktop__search--results__loading"
            );
          },
        });
      } else if ($(this).val().length <= 0) {
        if ($(this).hasClass("search-active")) {
          $(this).removeClass("search-active");
        }

        $(".site-header__nav--desktop__search--results").empty();
        if (
          $(".site-header__nav--desktop__search--results").hasClass(
            "site-header__nav--desktop__search--results__loading"
          )
        ) {
          $(".site-header__nav--desktop__search--results").removeClass(
            "site-header__nav--desktop__search--results__loading"
          );
        }
      }
    });

    $("#searchMobile").on("input", function (e) {
      e.preventDefault();
      if ($(this).val().length >= 3) {
        $(this).addClass("search-active");
        $.ajax({
          type: "POST",
          url: "/wp-admin/admin-ajax.php",
          dataType: "html",
          data: {
            action: "veluwse_search",
            query: $(this).val(),
          },
          beforeSend: function () {
            $(".site-header__nav--mobile__search--results").addClass(
              "site-header__nav--mobile__search--results__loading"
            );
            if (
              $(".site-header__nav--mobile__search--results").hasClass(
                "site-header__nav--mobile__search--results__active"
              )
            ) {
              $(".site-header__nav--mobile__search--results").removeClass(
                "site-header__nav--mobile__search--results__active"
              );
            }
          },
          success: function (res) {
            $(".site-header__nav--mobile__search--results").html(res);
            $(".site-header__nav--mobile__search--results").removeClass(
              "site-header__nav--mobile__search--results__loading"
            );
            $(".site-header__nav--mobile__search--results").addClass(
              "site-header__nav--mobile__search--results__active"
            );
          },
        });
      } else if ($(this).val().length <= 0) {
        if ($(this).hasClass("search-active")) {
          $(this).removeClass("search-active");
          $(".site-header__nav--mobile__search--results").removeClass(
            "site-header__nav--mobile__search--results__active"
          );
        }

        $(".site-header__nav--mobile__search--results").empty();
        if (
          $(".site-header__nav--mobile__search--results").hasClass(
            "site-header__nav--mobile__search--results__loading"
          )
        ) {
          $(".site-header__nav--mobile__search--results").removeClass(
            "site-header__nav--mobile__search--results__loading"
          );
        }

        if (
          $(".site-header__nav--mobile__search--results").hasClass(
            "site-header__nav--mobile__search--results__active"
          )
        ) {
          $(".site-header__nav--mobile__search--results").removeClass(
            "site-header__nav--mobile__search--results__active"
          );
        }
      }
    });
  });

  /* -------------------------------------------------------------------------- */
  /*                                 Search btn                                 */
  /* -------------------------------------------------------------------------- */
  searchFunc(
    ".header-search",
    ".site-header__nav--desktop__icons__search",
    ".search-closer",
    "desktop_search"
  );

  // searchFunc(
  //   ".mobile-btn__search",
  //   ".site-header__nav--mobile__search",
  //   ".search-closer",
  //   "searchMobile"
  // );
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("archiveSearch")) {
    jQuery(function ($) {
      $("#archiveSearch").on("change", function (e) {
        e.preventDefault();

        if ($(this).val().length >= 3) {
          $(this).addClass("search-active");

          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "duikhuis_archive_search",
              query: $(this).val(),
              cat: $(this).data("category"),
            },
            beforeSend: function () {
              $(".row-for-cards").addClass("row-loading");
            },
            success: function (res) {
              $(".row-for-cards").removeClass("row-loading");
              $(".row-for-cards").html(res);
            },
          });
        } else if ($(this).val().length <= 0) {
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "duikhuis_archive_search",
              query: "",
              cat: $(this).data("category"),
            },
            beforeSend: function () {
              $(".row-for-cards").addClass("row-loading");
            },
            success: function (res) {
              $(".row-for-cards").removeClass("row-loading");
              $(".row-for-cards").html(res);
            },
          });
        }
      });
    });
  }

  if (document.getElementById("shopSearch")) {
    jQuery(function ($) {
      $("#shopSearch").on("change", function (e) {
        e.preventDefault();

        if ($(this).val().length >= 3) {
          $(this).addClass("search-active");

          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "duikhuis_shop_search",
              query: $(this).val(),
              category: $(this).data("category"),
            },
            beforeSend: function () {
              $(".products").addClass("products-loading");
            },
            success: function (res) {
              $(".products").removeClass("products-loading");
              $(".products").html(res);
            },
          });
        } else if ($(this).val().length <= 0) {
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "duikhuis_shop_search",
              category: $(this).data("category"),
            },
            beforeSend: function () {
              $(".products").addClass("products-loading");
            },
            success: function (res) {
              $(".products").removeClass("products-loading");
              $(".products").html(res);
            },
          });
        }
      });
    });
  }

  if (document.getElementById("blogSearch")) {
    jQuery(function ($) {
      $("#blogSearch").on("change", function (e) {
        e.preventDefault();

        if ($(this).val().length >= 3) {
          $(this).addClass("search-active");

          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "duikhuis_blog_search",
              query: $(this).val(),
            },
            beforeSend: function () {
              $(".row-for-cards").addClass("row-loading");
            },
            success: function (res) {
              $(".row-for-cards").removeClass("row-loading");
              $(".row-for-cards").html(res);
            },
          });
        } else if ($(this).val().length <= 0) {
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
              action: "duikhuis_blog_search",
            },
            beforeSend: function () {
              $(".row-for-cards").addClass("row-loading");
            },
            success: function (res) {
              $(".row-for-cards").removeClass("row-loading");
              $(".row-for-cards").html(res);
            },
          });
        }
      });
    });
  }

  if (document.querySelector(".mobile-search")) {
    var mobileSearch = document.querySelector(".mobile-search");
    var inputWrap = document.querySelector(".mobile-search__input");
    var input = document.getElementById("mobileSearch");

    document.onkeydown = function (e) {
      e = e || window.event;
      var isEnter = false;
      if ("key" in e) {
        isEnter = e.key === "Enter";
      } else {
        isEnter = e.code === 13;
      }

      params = new URLSearchParams({
        s: input.value,
      });
      if (isEnter && input.value != "" && input.value.length >= 3) {
        window.open("/?" + params.toString(), "_self");
      }
    };
    mobileSearch.addEventListener("click", function (e) {
      e.preventDefault();

      params = new URLSearchParams({
        s: input.value,
      });
      if (this.classList.contains("search-active")) {
        if (input.value != "" && input.value.length >= 3) {
          window.open("/?" + params.toString(), "_self");
        }
      }

      inputWrap.classList.add("mobile-search__input--active");
      this.classList.add("search-active");

      setTimeout(function () {
        input.focus();
      }, 400);
    });

    input.addEventListener("focusout", function () {
      inputWrap.classList.remove("mobile-search__input--active");
      mobileSearch.classList.remove("search-active");
    });
  }
});
